// API utility functions with secure JWT token support

import { getToken, clearToken } from './tokenManager';
import logger from './logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Make authenticated API request with JWT token
 */
export const fetchWithAuth = async (url, options = {}) => {
  const token = getToken();
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(url, {
    ...options,
    headers,
    cache: 'no-store',
  });
  
  // If unauthorized, clear token and redirect
  if (response.status === 401) {
    clearToken();
    window.location.href = '/login';
    throw new Error('Session expired. Please log in again.');
  }
  
  return response;
};

/**
 * Logout user by clearing token and session
 */
export const logout = async () => {
  const token = getToken();
  clearToken();
  
  try {
    if (token) {
      await fetch(`${BACKEND_URL}/api/auth/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
    }
  } catch (error) {
    logger.error('Logout API error:', error);
  }
  
  window.location.href = '/';
};

export { BACKEND_URL };
